<template>
  <div id="vxaNote" v-loading="loading">
    <div id="notetrack" class="track">
      <div class="title">
        <vxa-tab class="vxa-tab" v-model="visibility" @click="handleClick" :tabList="visibilityTypes"></vxa-tab>
        <i class="el-icon-close" @click="closeWindow"></i>
      </div>
    </div>
    <template v-if="loaded">
      <div class="sort">
        <xa-select v-model="sortRule" placeholder="请选择" size="small" @change="handleSelectSort">
          <xa-option label="按原文条款排序" :value="0"></xa-option>
          <xa-option label="按编辑时间排序" :value="1"></xa-option>
        </xa-select>
        <div class="search">
          <xa-input
            :maxlength="50"
            placeholder="搜索笔记内容"
            v-model="keyWord"
            class="vxa-note-input-location"
            size="small"
            @keyup.enter.native="searchNoteStartPage"
          >
            <template slot="append">
              <xa-button type="primary" size="medium" class="search-btn" @click="searchNoteStartPage">
                <i class="el-icon-search"></i>
              </xa-button>
            </template>
          </xa-input>
        </div>
      </div>
      <div
        id="notelistContent"
        class="listContent"
        :style="{ height: contentHeight + 'px' }"
        v-if="searchNoteList.length > 0"
      >
        <div class="listBox" v-for="(item, index) in searchNoteList" :key="index">
          <div class="title-item">
            <img class="header-img" v-if="item.userAvatar" :src="item.userAvatar" />
            <img class="header-img" v-else :src="`${$api.aliyunDomain}xiaoan/h5_static/personal/timg@2x.png`" />
            <span class="title">{{ item.userName }}</span>
          </div>
          <div
            class="note-content vxa-note-edit-location"
            :class="{ pointer: item.userId == userId || (item.tag === '小安' && hasXiaoanNotePermission) }"
            v-htmlWithXssFilter="noteContentToHtml(item.noteContent)"
            v-show="!item.isEidt"
            @click="handleEdit(index, 'edit', item)"
          ></div>
          <div class="note-content" v-show="item.isEidt">
            <xa-input
              class="noteContent"
              type="textarea"
              v-model.trim="item.noteContent"
              :autosize="{ minRows: 4, maxRows: 50 }"
              placeholder="请输入内容"
              maxlength="500"
              resize="none"
            >
            </xa-input>
          </div>
          <div class="snippetbox" v-show="!item.isEidt">
            <div class="show-hidden">
              <span
                class="pointer vxa-note-show-article-location"
                v-if="!item.showSnippet"
                @click.stop="handleShowSnippet(index, 'show')"
                >显示原文 <i class="el-icon-arrow-down"></i
              ></span>
              <span class="pointer" v-else @click.stop="handleShowSnippet(index, 'hide')"
                >收起原文 <i class="el-icon-arrow-up"></i
              ></span>
              <div class="right-content">
                <xa-tooltip content="复制到我的笔记" v-if="item.userId !== userId">
                  <img
                    class="icon-img vxa-note-copy-location"
                    :src="$image.rules.copy"
                    style="height: 15px"
                    @click="handleAddLawNote(item)"
                  />
                </xa-tooltip>
                <span>编辑于{{ item.lastUpdateTime }}</span>
              </div>
            </div>
            <div
              class="snippet"
              :class="{ pointer: ruleDetailNoteModel }"
              v-htmlWithXssFilter="item.snippet"
              v-show="item.showSnippet"
              @click="scrollToNote(item)"
            ></div>
          </div>
          <div class="opt-box">
            <div class="btnBox" v-show="item.isEidt">
              <xa-button type="primary" size="small" @click="handleUpdateLawNote(item, index)">确定</xa-button>
              <xa-button class="cancel-btn" size="small" @click="handleEdit(index, 'cancel', item)">取消</xa-button>
              <xa-button
                v-if="item.userId == userId || (item.tag === '小安' && hasXiaoanNotePermission)"
                size="small"
                @click="deleteLawNote(item)"
                >删除</xa-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="center pagination" v-if="totalCount > 0">
        <xa-pagination
          mode="onlyPager"
          :current-page="pageNum"
          :total="totalCount"
          :page-size="pageSize"
          @currentChange="pageChange"
        >
        </xa-pagination>
      </div>
      <div v-else>
        <vxa-no-info></vxa-no-info>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeout1: null, // 定时器
      loading: false,
      lawId: '',
      userId: '',
      userInfo: '',
      contentHeight: 300,
      keyWord: '',
      visibility: '2',
      noteTypeValue: 0,
      searchNoteList: [],
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      loaded: false,
      visibilityTypes: [
        {
          label: '小安笔记',
          name: '2',
          list: []
        },
        {
          label: '个人笔记',
          name: '0',
          list: []
        }
      ],
      sortRule: 0,
      hasXiaoanNotePermission: false
    }
  },
  computed: {
    ruleDetailNoteModel() {
      return this.$store.state.rule.ruleDetailNoteModel
    }
  },
  created() {
    this.lawId = this.$route.params.id
    this.userInfo = this.$storage.getUserInfo()
    this.userId = this.$storage.getUserInfo().userId
    if (this.userInfo.companyId) {
      this.visibilityTypes.push({
        label: '企业内部笔记',
        name: '1',
        list: []
      })
    }
    this.get_law_notes()
    if (this.$storage.isLogin()) {
      this.xiaoan_note_permission()
    }
  },
  mounted() {
    this.changeStyle()
    window.onresize = () => {
      this.changeStyle()
    }
  },
  destroyed() {
    window.onresize = null
    clearTimeout(this.timeout1)
  },
  methods: {
    changeStyle() {
      this.$nextTick(() => {
        if (!document.querySelector('#vxaNote')) {
          return
        }

        var sidebarNote = document.querySelector('#vxaNote').clientHeight
        this.contentHeight = sidebarNote - 172

        this.timeout1 = setTimeout(() => {
          const eles = document.querySelectorAll('.noteContent textarea')
          for (let i = 0; i < eles.length; i++) {
            eles[i].style.maxHeight = sidebarNote / 2 + 'px'
          }
        }, 1000)
      })
    },
    handleSelectSort() {
      this.pageNum = 1
      this.get_law_notes()
    },
    searchNoteStartPage() {
      if (this.keyWord && this.keyWord.length == 1) {
        this.$xaToast({ message: '关键词至少填写两个字！', type: 'info' })
        return
      }
      this.pageNum = 1
      this.get_law_notes()
    },
    closeWindow() {
      this.$emit('isShow')
    },
    handleShowSnippet(index, key) {
      if (key == 'show') {
        this.$set(this.searchNoteList[index], 'showSnippet', true)
      } else {
        this.$set(this.searchNoteList[index], 'showSnippet', false)
      }
      this.searchNoteList = Object.assign([], this.searchNoteList)
    },
    scrollToNote(item) {
      const lastNoteText = document.getElementById(`text-${item.startContainerId}`)
      lastNoteText && lastNoteText.scrollIntoView({ block: 'center' })
      lastNoteText && this.closeWindow()
    },
    handleEdit(index, key, item) {
      if (item.userId == this.userId || (item.tag === '小安' && this.hasXiaoanNotePermission)) {
        this.searchNoteList.forEach(list => {
          list.isEidt = false
        })

        if (key == 'edit') {
          this.$set(this.searchNoteList[index], 'isEidt', true)
        }
        if (key === 'cancel') {
          this.$set(this.searchNoteList[index], 'noteContent', this.searchNoteList[index].noteContentCopy)
          this.$set(this.searchNoteList[index], 'visibility', this.searchNoteList[index].visibilityCopy)
        }

        this.searchNoteList = Object.assign([], this.searchNoteList)
      }
    },
    pageChange(index) {
      this.pageNum = index
      this.get_law_notes()
    },
    get_law_notes() {
      this.loading = true
      const params = {
        lawId: this.lawId,
        keyword: this.keyWord,
        visibility: Number(this.visibility),
        sortRule: this.sortRule,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        sourceId: this.userInfo.companyId
      }

      this.$axios.lawnote
        .get_law_notes(params)
        .then(res => {
          this.loading = false
          if (res.data.returnObject) {
            this.totalCount = res.data.returnObject.total
            this.searchNoteList = res.data.returnObject.data || []
            this.searchNoteList.forEach(item => {
              item.noteContentCopy = item.noteContent
              item.visibilityCopy = item.visibility
              item.showSnippet = false
              item.isEidt = false
              const snippet = this.$common.highLight(item.snippet, this.keyWord)
              item.snippet = snippet.replace(/\n+/g, '<br/>')
              item.lastUpdateTime = this.$common.formatDate(item.lastUpdateTime, 'YYYY-MM-DD HH:mm')
            })
          }
        })
        .finally(() => {
          this.loaded = true
        })
    },
    noteContentToHtml(noteContent) {
      noteContent = this.$common.highLight(noteContent, this.keyWord)
      return noteContent.replace(/\n/g, '<br/>')
    },
    // 删除笔记
    deleteLawNote(item) {
      this.$xaConfirm({
        message: '确定要删除吗?',
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      })
        .then(() => {
          const params = {
            noteIds: item.id
          }

          this.$axios.lawnote.delete_law_notes(params).then(res => {
            if (this.searchNoteList.length == 1) {
              this.pageNum = this.pageNum - 1
            }
            this.$store.commit('deleteLawNote', item.id)
            this.$xaToast({ message: '删除成功', type: 'success' })
            this.get_law_notes()
          })
        })
        .catch(() => {})
    },
    // 复制到我的笔记
    handleAddLawNote(item) {
      this.$xaConfirm({
        message: '确定要复制吗?',
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      }).then(() => {
        const params = {
          sourceId: this.userInfo.companyId || this.userId,
          lawId: item.lawId,
          snippet: item.snippet,
          visibility: 0,
          noteContent: item.noteContent,
          startContainerId: item.startContainerId,
          endContainerId: item.endContainerId,
          paragraph: item.paragraph
        }

        this.$axios.lawnote.add_law_notes(params).then(res => {
          this.sortRule = 0
          this.handleSelectSort()
          this.$xaToast({ message: '复制成功', type: 'success' })
        })
      })
    },
    handleUpdateLawNote(item, index) {
      if (item.noteContent.length === 0) {
        this.$xaToast({ message: '请输入内容', type: 'error' })
        return
      }
      const params = {
        id: item.id,
        sourceId: this.userInfo.companyId || this.userId,
        noteContent: item.noteContent,
        visibility: item.visibility,
        tag: item.tag
      }
      this.$axios.lawnote
        .update_law_notes(params, item.id)
        .then(res => {
          this.$set(this.searchNoteList[index], 'isEidt', false)
          this.searchNoteList = Object.assign([], this.searchNoteList)
          this.$store.commit('lawNoteUpdate', true)
          this.$xaToast({ message: '笔记修改成功', type: 'success' })
        })
        .catch(err => {
          if (err.response?.status == 500 && err.response.data.returnMsg) {
            this.$xaToast({ type: 'error', message: err.response.data.returnMsg })
            if (err.response.data.returnCode == 'B000401') {
              this.pageNum = 1
              this.get_law_notes()
            }
          } else {
            this.$xaToast({ type: 'error', message: '修改失败' })
          }
        })
    },
    handleClick() {
      this.pageNum = 1
      this.get_law_notes()
    },
    // 检查是否有小安笔记的权限
    xiaoan_note_permission() {
      this.$axios.lawnote
        .xiaoan_note_permission()
        .then(res => {
          this.hasXiaoanNotePermission = res.data.returnObject ?? false
        })
        .catch(err => {
          console.error(err)
          this.hasXiaoanNotePermission = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#vxaNote {
  height: 100%;
  padding: 0px;
  .flex {
    display: flex;
    align-items: center;
  }
  .track {
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    .title {
      position: relative;
      padding: 0 10px;
      width: 100%;
      height: 45px;
      font-size: 14px;
      color: #323232;
      transition: all 0.3s;
      .el-icon-close {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #8d8d8d;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .sort {
    padding: 0 10px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .xa-select {
      width: 150px;
    }
    .search {
      /deep/.el-input {
        .el-input-group__prepend {
          padding: 0;
          border-color: #ffb148;
        }
        .el-input-group__append {
          padding: 0;
          border-color: #ffb148;
        }
        .el-input__inner {
          height: 28px;
          line-height: 28px;
          border-right: none;
        }
      }
      .search-btn {
        min-width: unset;
        height: 26px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        /deep/ .el-icon-search {
          font-size: 16px;
        }
      }
    }
  }
  .filterbox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 10px;
  }
  .listContent {
    padding: 0 15px;
    overflow-y: auto;
    padding-bottom: 20px;
    .listBox {
      padding-top: 17px;
      .title-item {
        display: flex;
        align-items: center;
        height: 30px;
        .header-img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .title {
          font-size: 16px;
          color: #323232;
          display: inline-block;
          margin-left: 10px;
          width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .note-content {
        padding-left: 40px;
        font-size: 14px;
        color: #323232;
      }
      .snippetbox {
        font-size: 12px;
        color: #8d8d8d;
        padding-left: 40px;
        .show-hidden {
          padding: 5px 0 4px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .right-content {
            display: flex;
            align-items: center;
            .icon-img {
              margin-right: 8px;
              cursor: pointer;
              display: inline-block;
            }
          }
        }
        .snippet {
          margin-top: 4px;
          padding: 7px 0 7px 10px;
          background-color: #fffaf5;
          line-height: 18px;
        }
      }
      .opt-box {
        margin-left: 40px;
        padding: 4px 0 10px 0;
        border-bottom: 1px solid #e3e3e3;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        color: #8d8d8d;
        .btnBox {
          padding-top: 10px;
          text-align: right;
          .xa-button {
            font-size: 12px;
            &.cancel-btn {
              background: #ffffff;
              border: 1px solid #dcdfe6;
              border-color: #dcdfe6;
              color: #323232;
            }
          }
        }
      }
    }
  }
  .pagination {
    /deep/.el-pagination {
      margin-top: 20px;
    }
  }
}
</style>
